import { StateType } from './types';

export const STATES: StateType[] = [
  { abbreviation: 'AL', label: 'Alabama' },
  { abbreviation: 'AK', label: 'Alaska' },
  { abbreviation: 'AZ', label: 'Arizona' },
  { abbreviation: 'AR', label: 'Arkansas' },
  { abbreviation: 'CA', label: 'California' },
  { abbreviation: 'CO', label: 'Colorado' },
  { abbreviation: 'CT', label: 'Connecticut' },
  { abbreviation: 'DE', label: 'Delaware' },
  { abbreviation: 'DC', label: 'District of Columbia' },
  { abbreviation: 'FL', label: 'Florida' },
  { abbreviation: 'GA', label: 'Georgia' },
  { abbreviation: 'HI', label: 'Hawaii' },
  { abbreviation: 'ID', label: 'Idaho' },
  { abbreviation: 'IL', label: 'Illinois' },
  { abbreviation: 'IN', label: 'Indiana' },
  { abbreviation: 'IA', label: 'Iowa' },
  { abbreviation: 'KS', label: 'Kansas' },
  { abbreviation: 'KY', label: 'Kentucky' },
  { abbreviation: 'LA', label: 'Louisiana' },
  { abbreviation: 'ME', label: 'Maine' },
  { abbreviation: 'MH', label: 'Marshall Islands' },
  { abbreviation: 'MD', label: 'Maryland' },
  { abbreviation: 'MA', label: 'Massachusetts' },
  { abbreviation: 'MI', label: 'Michigan' },
  { abbreviation: 'MN', label: 'Minnesota' },
  { abbreviation: 'MS', label: 'Mississippi' },
  { abbreviation: 'MO', label: 'Missouri' },
  { abbreviation: 'MT', label: 'Montana' },
  { abbreviation: 'NE', label: 'Nebraska' },
  { abbreviation: 'NV', label: 'Nevada' },
  { abbreviation: 'NH', label: 'New Hampshire' },
  { abbreviation: 'NJ', label: 'New Jersey' },
  { abbreviation: 'NM', label: 'New Mexico' },
  { abbreviation: 'NY', label: 'New York' },
  { abbreviation: 'NC', label: 'North Carolina' },
  { abbreviation: 'ND', label: 'North Dakota' },
  { abbreviation: 'MP', label: 'Northern Mariana Islands' },
  { abbreviation: 'OH', label: 'Ohio' },
  { abbreviation: 'OK', label: 'Oklahoma' },
  { abbreviation: 'OR', label: 'Oregon' },
  { abbreviation: 'PW', label: 'Palau' },
  { abbreviation: 'PA', label: 'Pennsylvania' },
  { abbreviation: 'PR', label: 'Puerto Rico' },
  { abbreviation: 'RI', label: 'Rhode Island' },
  { abbreviation: 'SC', label: 'South Carolina' },
  { abbreviation: 'SD', label: 'South Dakota' },
  { abbreviation: 'TN', label: 'Tennessee' },
  { abbreviation: 'TX', label: 'Texas' },
  { abbreviation: 'UT', label: 'Utah' },
  { abbreviation: 'VT', label: 'Vermont' },
  { abbreviation: 'VI', label: 'Virgin Islands' },
  { abbreviation: 'VA', label: 'Virginia' },
  { abbreviation: 'WA', label: 'Washington' },
  { abbreviation: 'WV', label: 'West Virginia' },
  { abbreviation: 'WI', label: 'Wisconsin' },
  { abbreviation: 'WY', label: 'Wyoming' },
];
